import { Round } from "./Math"

/** @pure */
export const RoundTo = <T extends number>(val: T, decimals = 0): T => {
  const roundTo = 10 ** decimals
  return (Round(roundTo * val) / roundTo) as T
}
